"use client";

import type { QuestionnaireProps } from "@/app/directories/shop/[clientSlug]/types";
import { useState } from "react";
import { QuestionnaireButton } from "./QuestionnaireButton";
import { QuestionnaireModal } from "./QuestionnaireModal";

export function QuestionnaireComponent({
  style,
  props,
  params,
}: {
  style: string;
  props: QuestionnaireProps;
  params: { clientSlug: string; orgId: number };
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className={style}>
      <QuestionnaireButton
        buttonText={props.buttonText}
        buttonStyle={props.buttonStyle}
        onOpenModal={() => setIsModalOpen(true)}
      />
      <QuestionnaireModal
        open={isModalOpen}
        setOpen={setIsModalOpen}
        questions={props.questions}
        orgId={params.orgId}
      />
    </div>
  );
}
